






































































import Vue from "vue";
import { getModule } from "vuex-module-decorators";
import SubscriptionSignup from "@/store/modules/SubscriptionSignup";
import PromoCodeField from "@/components/Subscriptions/PromoCodeField.vue";
import moment from "moment/moment";
import { bus } from "@/main";

interface State {
  store: SubscriptionSignup;
}

export default Vue.extend({
  name: "LicenseTotal",
  components: { PromoCodeField },
  data(): State {
    return {
      store: getModule(SubscriptionSignup, this.$store)
    };
  },
  methods: {
    removePromo() {
      this.store.clearPromotion();
      bus.$emit("successSnack", "Promo code removed");
    }
  },
  computed: {
    selectedInterval(): any | null {
      const selectedSubscription = [
        this.store.yearlySubscriptionData,
        this.store.monthlySubscriptionData
      ].find(
        (subData: any) => subData.price === this.store.subscriptionVO.priceId
      );
      return selectedSubscription ? selectedSubscription : null;
    },
    trialDates(): string {
      const startTrial = moment.now();
      const endTrial = moment(startTrial).add(1, "M");
      return `${moment(startTrial).format("MMMM DD")} - ${moment(
        endTrial
      ).format("MMMM DD, yyyy")}`;
    },
    billingDates(): string {
      const startBilling = moment(moment.now()).add(1, "M");
      const nextBilling =
        this.selectedInterval.billingFrequencyTitle === "Annual"
          ? moment(startBilling).add(1, "year")
          : moment(startBilling).add(1, "M");
      return `${moment(startBilling).format("MMMM DD, yyyy")} - ${moment(
        nextBilling
      ).format("MMMM DD, yyyy")}`;
    }
  }
});
